module.exports = __webpack_public_path__ + "img/logo.448fa703.png";